<template>
  <div
    class="main-left-filter"
    :class="locale | rtlTextClass"
  >
    <el-row>
      <span class="filter-title">{{ $t('filter.category.label') }}</span>
      <category-select />
    </el-row>
    <dynamic-fields />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import CategorySelect from './CategorySelect';
  import DynamicFields from './LeftFilter/DynamicFields';

  export default {
    components: {
      CategorySelect,
      DynamicFields,
    },
    computed: {
      ...mapState({
        locale: state => state.locale,
      }),
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainLeftFilters/LeftFilter.vue